module.exports = __webpack_public_path__ + "media/evolve/assets/icons/animated/upload-9f781e8265dd77d0ee5006ae349c1e11.svg";